import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { openApiService } from '../Services/openApiService';
import useGlobals from './useGlobals';
import { setModal } from '../Store/Actions/modalActions';
import toast from 'react-hot-toast';
import { PaginationListType } from '../Types/PaginationParams';
import { setListReloadType } from '../Store/Actions/environmentActions';
import { OpenApiConfig } from '../Types';

const useOpenApiConfigs = () => {
    const navigate = useNavigate();
    const { i18n, dispatch, windowWidth } = useGlobals();

    const handleCreateNew = () => {
        navigate('/admin/openapiconfig/new');
    };

    const handleEdit = (config: OpenApiConfig) => {
        navigate(`/admin/openapiconfig/${config.identifier}`);
    };

    const handleDelete = useCallback(
        async (id: string) => {
            try {
                await openApiService.deleteConfig(id);
                dispatch(setModal({ state: 'closed' }));
                dispatch(setListReloadType(PaginationListType.OpenApiConfigs));
                toast.success(i18n.translate({ id: 'config.delete.success', sourceName: 'OpenAPI' }));
            } catch (error) {
                console.error('Error deleting OpenAPI config:', error);
                toast.error(i18n.translate({ id: 'config.delete.error', sourceName: 'OpenAPI' }));
            }
        },
        [dispatch, i18n],
    );

    const handleOpenConfirmDialog = useCallback(
        (id: string, title: string) => {
            dispatch(
                setModal({
                    state: 'open',
                    title: i18n.translate({ id: 'config.delete.title', sourceName: 'OpenAPI' }),
                    content: i18n.translate({
                        id: 'config.delete.text',
                        sourceName: 'OpenAPI',
                        params: {
                            title: title,
                        },
                    }),
                    buttonRightText: i18n.translate({ id: 'config.delete.button', sourceName: 'OpenAPI' }),
                    buttonRightAction: () => handleDelete(id),
                    buttonLeftText: i18n.translate({ id: 'config.delete.cancel', sourceName: 'OpenAPI' }),
                    buttonLeftAction: () => dispatch(setModal({ state: 'closed' })),
                    modalSize: 'medium',
                    closeOnAction: true,
                    showCloseButton: true,
                }),
            );
        },
        [dispatch, i18n, handleDelete],
    );

    return {
        handleOpenConfirmDialog,
        i18n,
        windowWidth,
        handleEdit,
        handleCreateNew,
    };
};

export default useOpenApiConfigs;
